import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import useSelectedDomain from '../service/Hooks/useSelectedDomain';
import { submitApproval } from '../service/api/approvalService';
import { useUserData } from '../service/api/useUserData';

const ValidationModal = ({
  show,
  onClose,
  entityId,
  entityType,
  onValidationSuccess,
}) => {
  const [comments, setComments] = useState('');
  const [action, setAction] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [commentsError, setCommentsError] = useState('');

  const { getUserInfo } = useUserData();
  const selectedDomain = useSelectedDomain();
  // const currentUser = getUserInfo();
  const [role, setRole] = useState(null);
  const [managerDomain, setManagerDomain] = useState(null);

  useEffect(() => {
    async function fetchUserData() {
      
    }
    fetchUserData();
  }, []);

  useEffect(() => {
    if (show) {
      setComments('');
      setAction(null);
      setCommentsError('');
    }
  }, [show]);

  const validateForm = () => {
    if (!comments.trim()) {
      setCommentsError('Le commentaire est obligatoire.');
      return false;
    }
    setCommentsError('');
    return true;
  };

  const handleSubmit = async (isApproved) => {

    const userInfo = await getUserInfo();
      if (!userInfo) return;
  
      const { accountId, isAdmin, selectedDomain } = userInfo;

      if (isAdmin) {
        setRole("admin");
      } else {
        const storedDomain = localStorage.getItem("selectedDomain");
        if (storedDomain) {
          const domainObj = JSON.parse(storedDomain);
          setRole(domainObj.role);
          setManagerDomain(domainObj);
        } else if (selectedDomain?.role) {
          setRole(selectedDomain.role);
          setManagerDomain(selectedDomain);
        } else {
          setRole("client");
        }
      }

    setAction(isApproved ? 'approve' : 'reject');
    if (!validateForm()) {
      return;
    }

    if (!accountId) {
      toast.error("ID de l'utilisateur connecté introuvable.");
      return;
    }


    if (!selectedDomain || !selectedDomain.id) {
      toast.error("Domaine sélectionné introuvable.");
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        entityId: entityId,
        entityType: entityType,
        currentManagerAccountId: accountId,
        isApproved: isApproved,
        comments: comments.trim(),
        domainId: selectedDomain.id,
      };

      // console.log("Payload sent to API via service:", payload); // Log for debugging

      // Utiliser le nouveau service pour soumettre l'approbation
      const success = await submitApproval(payload);

      if (success) {
        toast.success(`${entityType} ${isApproved ? 'approuvé' : 'rejeté'} avec succès !`);
        onValidationSuccess();
        onClose();
      }
      // No 'else' here, as submitApproval service throws an error on failure, which is caught below
    } catch (error) {
      // L'erreur contient déjà le message convivial du service
      toast.error(error.message);
      console.error("Error caught in ValidationModal:", error); // Log the full error for dev
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className={`modal fade ${show ? 'show d-block' : ''}`}
      tabIndex="-1"
      aria-labelledby="validationModalLabel"
      aria-hidden={!show}
      style={{ backgroundColor: show ? 'rgba(0,0,0,0.5)' : 'transparent' }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header text-white">
            <h5 className="modal-title" id="validationModalLabel">
              Valider {entityType === 'account' ? 'le Compte' : 'l\'Ordre'} #{entityId}
            </h5>
            <button type="button" className="btn-close btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="comments" className="form-label fw-bold">Commentaires <span className="text-danger">*</span></label>
              <textarea
                className={`form-control ${commentsError ? 'is-invalid' : ''}`}
                id="comments"
                rows="3"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                placeholder="Veuillez saisir votre commentaire ici..."
                required
              ></textarea>
              {commentsError && <div className="invalid-feedback">{commentsError}</div>}
            </div>
            <p className="text-muted small">
              Veuillez ajouter un commentaire pour justifier votre action (approbation ou rejet).
            </p>
            <p className="text text-bg-warning fw-bold p-2">
              ATTENTION : Veillez bien verifier avant de prendre une decision car tout changement apres que le status de l'action (ordre ou compte) est change(de l'attente a valider ou rejeter) est irreverssible (approbation ou rejet).
            </p>
          </div>
          <div className="modal-footer justify-content-between">
            <button
              type="button"
              className="btn btn-danger btn-lg me-2"
              onClick={() => handleSubmit(false)}
              disabled={isSubmitting && action === 'reject'}
            >
              {isSubmitting && action === 'reject' ? 'Rejet en cours...' : 'Rejeter'}
            </button>
            <button
              type="button"
              className="btn btn-success btn-lg ms-auto"
              onClick={() => handleSubmit(true)}
              disabled={isSubmitting && action === 'approve'}
            >
              {isSubmitting && action === 'approve' ? 'Approbation en cours...' : 'Approuver'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidationModal;